// extracted by mini-css-extract-plugin
export var dayLabel = "_lc-0";
export var pickerDisabled = "_lc-1";